<template>
    <ContainerLayout page="3" :loading="loading">
        <div class="content">
            Ticket Page
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";

export default {
    name: "TicketIndex",
    data() {
        return {
            loading: false,
        };
    },
    components: {
        ContainerLayout
    },
};
</script>
  